import CreateEventWizardApp from "./CreateEventWizardApp.vue";
import { vueAppWithPinia } from "../../Common/vueApp";

export default vueAppWithPinia(CreateEventWizardApp);
